(function(angular){
	'use strict';
	
	angular
		.module('serviceLevelModule', 
		[
			'apiModule',
			'coreModule',
			'collapseModule',
			'formValidationModule',
			'hypotheticalPerformanceModule',
			'planModule',
			'planVariantSelectModule',
			'progressBarModule',
			'progressIndicatorModule'
		])
		.filter('serviceLevelLabel', function(){
			return function(input) {
				var label;
				switch(input) {
					case 'PREMIUM':
						label = 'Premium';
						break;
					case 'ADVANCED':
						label = 'Advanced';
						break;
					case 'CORE':
						label = 'Core';
						break;
					case 'STARTER':
						label = 'Starter';
						break;
				}
				return label;
			};
		});

})(window.angular);